import React from "react";
import { Box, Typography } from "@mui/material";

const CountdownBox = ({ value, label }) => (
  <Box sx={{ textAlign: "center" }}>
    <Box
      sx={{
        background: "#00000055",
        border: "1px solid #ffffff22",
        borderRadius: "10px",
        px: { xs: 1.2, md: 2 },
        py: { xs: 0.6, md: 1 },
        minWidth: { xs: 44, md: 60 },
        boxShadow: "0 6px 14px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.06)",
      }}
    >
      <Typography sx={{ color: "#fff", fontWeight: 800, fontSize: { xs: "18px", md: "26px" } }}>
        {String(value ?? 0).padStart(2, "0")}
      </Typography>
    </Box>
    <Typography sx={{ color: "#ffffffaa", fontSize: "11px", mt: 0.5, textTransform: "uppercase" }}>
      {label}
    </Typography>
  </Box>
);

export default CountdownBox;
